import React from "react";
import { ListingEvents, usePWA } from "@seims/shared";
import { Alert, Button } from "antd";
import { Link } from "react-router-dom";

import { RenderAnonymous, RenderAuthenticated } from "@seims/shared/src/security";
import { EventsLandingPage } from "./EventsLandingPage";


export const HomeView = () => {
  const { isOnline } = usePWA();

  return (
    <>
      {!isOnline && (
        <Alert
          style={{ margin: "16px" }}
          showIcon
          type="warning"
          message="You are offline"
          // description={
          //   <Link to="/events/offline-capture">
          //     <Button type="primary">Open Data Capture Page</Button>
          //   </Link>
          // }
        />
      )}

      <RenderAuthenticated>
        <ListingEvents />
      </RenderAuthenticated> 

      <RenderAnonymous>
        {/* <CorousalView /> */}
        <EventsLandingPage />
        {/* <ProgrammesView /> */}
        {/* <StakeholdersView /> */}
      </RenderAnonymous>

    </>
  );
};
